const window = global.window as any;
export const callWAReq = () => {
    postCallWAReq();
};

function postCallWAReq() {
    try {
        if (!sessionStorage.getItem('__tmpRef')) {
            if (document.referrer?.length > 0) {
                sessionStorage.setItem('__tmpRef', document.referrer);
            }
        }
        clearWAParam();

        var pvar = {
            content: '0',
            server: 'secure-sg',
            page_url: document.location,
            referrer: sessionStorage.getItem('__tmpRef'),
        };

        WATrackerTrackPageView(pvar);
        sessionStorage.setItem('__tmpRef', document.location.toString());
    } catch (e) {}
}

const clearWAParam = () => {
    try {
        window.s.pageName = undefined;
        window.s.prop1 = undefined;
        window.s.prop10 = undefined;
        window.s.eVar10 = undefined;
        window.s.eVar31 = undefined;
        window.s.prop7 = undefined;
        window.s.eVar7 = undefined;

        if (sessionStorage.getItem('__tmpRef')) {
            window.s.prop6 = sessionStorage.getItem('__tmpRef');
        }
    } catch (e) {}
};

const WATrackerTrackPageView = (eventId: any) => {
    if (typeof window.WATracker !== 'undefined' && window.WATracker) {
        try {
            window.WATracker.trackPageView(eventId);
        } catch (err) {
            console.log('WATrackerTrackPageView', err);
        }
    }
};
